import React, { useEffect, useState, useCallback } from 'react'
import { TextField, Grid, Box, Button, FormHelperText } from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DriveUsTenSchema } from '../../Utils/Validations'
import FileValidations from '../FileValidation/FileValidations'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'lightbox2/dist/css/lightbox.min.css';
import lightbox from 'lightbox2';
import $ from 'jquery';

const DriveWithUsTen = ({ handleBack, handleComplete, driveUsData, setDriveUsData, }) => {

  const { CheckFile, fileError } = FileValidations()
  const [fh1_insurance_expiry, setFh1_insurance_expiry] = React.useState(null);
  const [liability_insurance_expiry, setLiability_insurance_expiry] = React.useState(null);
  const [fh1_insurance_pic, setFh1_insurance_pic] = useState()
  const [liability_insurance_pic, setLiability_insurance_pic] = useState()
  const [openImage, setOpenImage] = useState("")
  const [openModal, setOpenModal] = useState(false)
  const { handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(DriveUsTenSchema)
  })

  useEffect(() => {
    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true,
    });

    const liab = driveUsData.liability_insurance_expiry
      ? dayjs(driveUsData.liability_insurance_expiry)
      : null;
    const fh1 = driveUsData.fh1_insurance_expiry
      ? dayjs(driveUsData.fh1_insurance_expiry)
      : null;

    setLiability_insurance_expiry(liab);
    setFh1_insurance_expiry(fh1);

    setValue("liability_insurance_expiry", liab);
    setValue("fh1_insurance_expiry", fh1);

  }, [driveUsData.liability_insurance_expiry, driveUsData.fh1_insurance_expiry, setValue])

  const handleDateChange = useCallback((newValue, onChange) => {
    setLiability_insurance_expiry(newValue);
    onChange(newValue);
  }, []);

  const handleFh1DateChange = useCallback((newValue, onChange) => {
    setFh1_insurance_expiry(newValue);
    onChange(newValue);
  }, []);


  const onSubmit = (data) => {
    if (Object.keys(fileError).length === 0) {
      console.log(data)
      setDriveUsData((prev) => ({ ...prev, fh1_insurance_pic: fh1_insurance_pic, fh1_insurance_expiry: fh1_insurance_expiry, liability_insurance_pic: liability_insurance_pic, liability_insurance_expiry: liability_insurance_expiry }))

      handleComplete()
    }

  }





  const onChangeFiles = (file, name) => {
    if (!file) {
      console.warn('No file selected');
      return;
    }

    // Use setTimeout to handle file processing asynchronously without blocking the form
    setTimeout(() => {
      try {
        CheckFile(file, name);

        if (name === "fh1_insurance_pic") {
          setFh1_insurance_pic(file)
        } else if (name === "liability_insurance_pic") {
          setLiability_insurance_pic(file)
        }
      } catch (error) {
        console.error('Error handling file selection:', error);
      }
    }, 50); // Small delay for mobile devices
  }

  const handleOpenModal = (image) => {
    setOpenModal(true)
    setOpenImage(image)
    setTimeout(() => {
      $(document).ready(() => {
        $(`[href="${image}"]`).click();
      });
    }, 0);



  }

  return (
    <div>
      {openModal && (
        <a
          href={`${openImage}`}
          data-lightbox="gallery"
          data-title="Image"
          style={{ display: 'none' }}
        >
          Open Image
        </a>
      )}
      <Grid container style={{ justifyContent: "center", marginTop: 20 }} >



        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 }, mt: 3 }} >
          <Controller
            control={control}
            name="liability_insurance_pic"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>
                <label>Liability Insurance </label>
                <TextField
                  fullWidth
                  type="file"
                  value={value}
                  onBlur={onBlur}
                  inputProps={{
                    onChange: (e) => {
                      const file = e.target.files?.[0];
                      if (file) {
                        onChange(e);
                        onChangeFiles(file, "liability_insurance_pic");
                      }
                    },
                    accept: "image/*,.pdf,.doc,.docx"
                  }}
                  error={errors?.liability_insurance_pic || fileError?.liability_insurance_pic}
                  helperText={errors?.liability_insurance_pic?.message || fileError?.liability_insurance_pic?.message}
                />
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} >
                  <Box>
                    <span className='image-detail' >Select any file or image</span><br />
                    <span className='image-detail' >Maximum file size: 50MB</span>

                  </Box>
                  <img src='/driver_forms/assets/images/CERTIFICATE OF LIABILITY.jpg' style={{ height: 50 }} onClick={() => handleOpenModal("/driver_forms/assets/images/CERTIFICATE OF LIABILITY.jpg")} />
                </Box>
              </>
            )}
          />


        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, mt: 3 }}>
          <Controller
            control={control}
            name="liability_insurance_expiry"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>

                <label>Liability Insurance Expiry</label>
                <DatePicker
                  sx={{ width: "100%" }}
                  className='date-picker'
                  value={value}
                  onChange={(newValue) => handleDateChange(newValue, onChange)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: !!errors.liability_insurance_expiry,
                      helperText: errors.liability_insurance_expiry?.message
                    }
                  }}
                />
                {errors.liability_insurance_expiry ? <FormHelperText component="p" sx={{ color: "#d32f2f", px: 1.5 }} >{errors.liability_insurance_expiry?.message}</FormHelperText> : null}
              </>
            )}
          />


        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 }, mt: 3 }} >
          <Controller
            control={control}
            name="fh1_insurance_pic"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>

                <label>FH-1 Insurance Certificate </label>
                <TextField
                  fullWidth
                  type="file"
                  value={value}
                  onBlur={onBlur}
                  inputProps={{
                    onChange: (e) => {
                      const file = e.target.files?.[0];
                      if (file) {
                        onChange(e);
                        onChangeFiles(file, "fh1_insurance_pic");
                      }
                    },
                    accept: "image/*,.pdf,.doc,.docx"
                  }}
                  error={errors?.fh1_insurance_pic || fileError?.fh1_insurance_pic}
                  helperText={errors?.fh1_insurance_pic?.message || fileError?.fh1_insurance_pic?.message}
                />
                <span className='image-detail' >Select any file or image</span><br />
                <span className='image-detail' >Maximum file size: 50MB</span>
              </>
            )}
          />


        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, mt: 3 }}>
          <Controller
            control={control}
            name="fh1_insurance_expiry"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>

                <label>FH-1 Insurance Expiry</label>
                <DatePicker
                  sx={{ width: "100%" }}
                  className='date-picker'
                  value={value}
                  onChange={(newValue) => handleFh1DateChange(newValue, onChange)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: !!errors.fh1_insurance_expiry,
                      helperText: errors.fh1_insurance_expiry?.message
                    }
                  }}
                />
                {errors.fh1_insurance_expiry ? <FormHelperText component="p" sx={{ color: "#d32f2f", px: 1.5 }} >{errors.fh1_insurance_expiry?.message}</FormHelperText> : null}
              </>
            )}
          />


        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, pb: 3 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{ minWidth: "10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          Next
        </Button>

      </Box>
    </div>
  )
}

export default DriveWithUsTen